import { gtmApiHelper } from "../gtm/gtm-api-helper";

export async function useClickSnsEffect(param) {
  await gtmApiHelper.click_sns(param);
}